module.exports = __webpack_public_path__ + "static/img/xiazai_duan.f443f5bb.png";